/** @format */

import React, { useState, useEffect } from "react";

import data from "./data.json";
import Table15 from "./Table15";
import excel from "../../../../../icons/excel.png";
import ContentTop from "../../../components/ContentTop";
import { ExcelPrint } from "../../../../../components/functions/Print";

const NovegetatsiyaSahifa = () => {
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [ldate, setLdate] = useState(date);

  useEffect(() => {
    setDate(ldate);
  }, [ldate]);

  return (
    <div>
      <ContentTop>
        <ul className='content-top-left in-menu'>
          <li>Novegetatsiya</li>
        </ul>

        <ul className='table-top-right d-flex align-items-center'>
          <li>
            <button
              className='btn p-0'
              onClick={() => ExcelPrint("Vegetatsiya", "sheet 1", "tblData")}>
              <img src={excel} alt='404' />
            </button>
          </li>

          <input
            type='date'
            className='form-control form-control-sm'
            value={ldate}
            onChange={(e) => setLdate(e.target.value)}
          />
        </ul>
      </ContentTop>

      <div className='tabs-content table-box'>
        <div className='tabs-content-item active controlling-table'>
          <Table15 date={ldate} data={data} />
        </div>
      </div>
    </div>
  );
};

export default NovegetatsiyaSahifa;
